import { calendarAccountsApi } from '~/Providers/Api';
import { success, error } from '~/Redux/Modules/Notifications';
import { parseErrors } from '~/Redux/Helpers';
import { getUserOptions } from '~/Redux/Modules/UserOptions';

import {
  SET_ACCOUNT,
  UPDATE_ACCOUNT as UPDATE_CALENDAR_ACCOUNT,
} from '~/Redux/Modules/CalendarAccounts';
import { GOOGLE } from '~/Config/Drivers';
import clevertapProvider, { CalendarAccountConnectedEvent } from '~/Providers/CleverTap';

const ADD_ACCOUNT = 'artful-client/Google/ADD_ACCOUNT';
const ADD_ACCOUNT_SUCCESS = 'artful-client/Google/ADD_ACCOUNT_SUCCESS';
const ADD_ACCOUNT_FAILURE = 'artful-client/Google/ADD_ACCOUNT_FAILURE';

const UPDATE_ACCOUNT = 'artful-client/Google/UPDATE_ACCOUNT';
const UPDATE_ACCOUNT_SUCCESS = 'artful-client/Google/UPDATE_ACCOUNT_SUCCESS';
const UPDATE_ACCOUNT_FAILURE = 'artful-client/Google/UPDATE_ACCOUNT_FAILURE';

const initialState = {
  isFetching: false,
  isUpdating: false,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case ADD_ACCOUNT:
      return { ...state, isFetching: true };
    case ADD_ACCOUNT_SUCCESS:
      return { ...state, isFetching: false };
    case ADD_ACCOUNT_FAILURE:
      return { ...state, isFetching: false };
    case UPDATE_ACCOUNT:
      return { ...state, isUpdating: true };
    case UPDATE_ACCOUNT_SUCCESS:
    case UPDATE_ACCOUNT_FAILURE:
      return { ...state, isUpdating: false };
    default:
      return state;
  }
}

export const googleCallback = data => async dispatch => {
  dispatch({ type: ADD_ACCOUNT });
  try {
    let response = await calendarAccountsApi.linkAccount('google', data);
    clevertapProvider.logEvent(new CalendarAccountConnectedEvent(GOOGLE));
    dispatch({ type: ADD_ACCOUNT_SUCCESS });
    dispatch({ type: SET_ACCOUNT, account: response.data });
    dispatch(getUserOptions());
    dispatch(success('Google account added!'));
    return response;
  } catch (err) {
    dispatch({ type: ADD_ACCOUNT_FAILURE, error: err });
    dispatch(error('Google account add failed', parseErrors(err)));
  }
};

export const updateGoogleAccount = data => async dispatch => {
  dispatch({ type: UPDATE_ACCOUNT });
  try {
    let response = await calendarAccountsApi.updateAccount({ id: data.id }, data);
    dispatch({ type: UPDATE_ACCOUNT_SUCCESS });
    dispatch({ type: UPDATE_CALENDAR_ACCOUNT, account: response.data });
    dispatch(getUserOptions());
    dispatch(success('Google account updated!'));
    return response;
  } catch (err) {
    dispatch({ type: UPDATE_ACCOUNT_FAILURE, error: err });
    dispatch(error('Google account update failed', parseErrors(err)));
  }
};

export const googleAccount = ({ CalendarAccounts }) =>
  CalendarAccounts.data.find(c => c.driver === GOOGLE);
